<template>
  <v-container>
    <v-row>
      <v-autocomplete
        :items="currentGroup"
        v-model="currNapr"
        :label="appOptions.settings.labelGroup"
        :item-color="vidgetOptions.colorField.hex"
        hide-details
        :outlined="vidgetOptions.outland"
        :persistent-hint="vidgetOptions.presentHint"
        :rounded="vidgetOptions.rounded"
        :shaped="vidgetOptions.shaped"
        :solo="vidgetOptions.solo"
        :color="vidgetOptions.colorField.hex"
        @change="changeNapr"
        return-object
      />
    </v-row>

    <v-row>
      <v-autocomplete
        clearable
        class="mt-3"
        :items="currentSpec"
        :color="vidgetOptions.colorField.hex"
        :item-color="vidgetOptions.colorField.hex"
        v-model="currSpec"
        :label="appOptions.settings.labelSpecialist"
        :disabled="!currNapr"
        hide-details
        :outlined="vidgetOptions.outland"
        :persistent-hint="vidgetOptions.presentHint"
        :rounded="vidgetOptions.rounded"
        :shaped="vidgetOptions.shaped"
        :solo="vidgetOptions.solo"
        @change="changeSotr"
      >
        <template v-slot:item="data">
          <template v-if="(typeof data.item !== 'object')">
            <v-list-item-content v-text="data.item"></v-list-item-content>
          </template>
          <template v-else>
            <v-list-item-avatar v-show="data.item.avatar">
              <img :src="data.item.avatar">
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.text"></v-list-item-title>
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>
    </v-row>

    <v-row v-if="!vidgetOptions.noSelectProduct">
      <v-autocomplete
        clearable
        class="mt-3"
        chips
        :items="itemsProductForPrint"
        return-object
        multiple
        :color="vidgetOptions.colorField.hex"
        :item-color="vidgetOptions.colorField.hex"
        :disabled="!currSpec"
        v-model="arrProduct"
        :label="appOptions.settings.labelProduct"
        hide-details
        :outlined="vidgetOptions.outland"
        :persistent-hint="vidgetOptions.presentHint"
        :rounded="vidgetOptions.rounded"
        :shaped="vidgetOptions.shaped"
        :solo="vidgetOptions.solo"
        @change="changeProductArr"
      >
        <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="data.select"
                    @click:close="remove(data.item)"
                  >
                    {{ data.item.text}}
                  </v-chip>
                </template>

        <template v-slot:item="data">
              <v-list-item-content>
                      <v-list-item-title>{{data.item.text}}</v-list-item-title>
                      <v-list-item-subtitle v-for="(item, idx) in data.item.otherFields" :key="data.item.value+'_'+idx">
                        <b>{{item.label}}:</b>  {{item.value}}
                      </v-list-item-subtitle>                      
              </v-list-item-content>
        </template>
      </v-autocomplete>
    </v-row>

    <v-row class="mt-6">
      <v-label>
      {{ $t("onlineForm.setNapravl.duration", {minutes: longPeriod}) }}
      </v-label>
    </v-row>

    <v-row class="mt-6">
      <v-date-picker
        full-width
        :color="vidgetOptions.colorField.hex"
        :disabled="localLoading||!currNapr||!currSpec"
        v-model="picker"
        :first-day-of-week="1"
        :allowed-dates="allowedDates"
        locale="ru-ru"
        :picker-date.sync="pickerMonthYear"
        @change="changeDate"
      ></v-date-picker>
    </v-row>
    
    <v-row class="mt-6" v-if="times.length>0&&!vidgetOptions.noSelectDate">
      <h3>{{ $t("onlineForm.setNapravl.selectTime") }}:</h3>
    </v-row>
    <v-row v-if="!vidgetOptions.noSelectDate">
      <v-chip
        :class="timeEl==selectedTime?'grey ma-3':'ma-3'"
        v-for="(timeEl, keyTime) in times"
        :key="'times_'+keyTime"
        @click="timeEl==selectedTime?selectedTime=undefined:selectTime(timeEl)"
      >
        {{timeEl.text}}
      </v-chip>
    </v-row>

    <v-row v-show="selectedTime!=undefined"
            class="mt-3"
            justify="end"
    >
      <v-btn
        :color="vidgetOptions.colorField.hex"
        text
        @click="$emit('update:currStep', currStep+1)"
      >
        {{ $t("global.continue") }}
      </v-btn>
    </v-row>

    
  </v-container>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'StepSetNapravl',

    methods:{
      changeDate:function(){
        if (this.times.length>0&&!this.vidgetOptions.noSelectTime){
          this.selectedTime=this.times[0];
        }
        this.$root.$emit('sendEventYandexGoogle', "myWebStor_changeDate");
      },
      selectTime(val){
        this.selectedTime=val;
        this.$root.$emit('sendEventYandexGoogle', "myWebStor_selectTime");
      },
      getPrintedTime:function(val){
        if (isNaN(Number(val))){
          return "";
        }
        var tempDate=new Date(Number(val));
        return tempDate.toISOString().substr(11,5);
      },
      remove:function(item){
        var currKey=undefined;
        var currElement=this.arrProduct.find((el, key)=>{
          if (el.value==item.value){
            currKey=key;
            return true;
          }
          return false;
        })
        if (currElement!=undefined){
          this.arrProduct.splice(currKey, 1);
        }
        this.$root.$emit('sendEventYandexGoogle', "myWebStor_changeProduct");
      },
      changeProductArr:function(){
        if (this.vidgetOptions.countProduct>0&&this.arrProduct.length>this.vidgetOptions.countProduct){
          this.arrProduct.splice(this.arrProduct.length-1,1);
        }
        // this.picker=undefined;
        this.$emit('update:dateResourse', undefined);
        this.selectedTime=undefined;
        this.$root.$emit('sendEventYandexGoogle', "myWebStor_changeProduct");
      },
      testJSON:function(JsonStr){
        try {
          JSON.parse(JsonStr);
          return true;
        } catch (error) {
          return false;
        }
      },
      changeSotr:function(){
        // this.picker=undefined;
        this.arrProduct=[];
        this.$emit('update:dateResourse', undefined);
        this.selectedTime=undefined;
        this.$root.$emit('sendEventYandexGoogle', "myWebStor_changeSotr");
        if (this.currSpec){
          this.$emit('update:localLoading', true);
          let findedSotr=this.currentSpec.find(el=>{
            return el.value==this.currSpec;
          });
          if (findedSotr){
            let propsAxios={
              tokenForm:this.formToken,
              action:'getProducts'
            }            
            let objCatalog=this.testJSON(findedSotr.catalog)?JSON.parse(findedSotr.catalog):{arValues:[]};
            if (objCatalog.arValues.length>0){
              propsAxios.catalogId=objCatalog.arValues;
            }
            else{
              objCatalog=this.testJSON(this.currNapr.catalog)?JSON.parse(this.currNapr.catalog):{arValues:[]};
              if (objCatalog.arValues.length>0){
                propsAxios.catalogId=objCatalog.arValues;
              }
            }
            
            axios.post('https://crm.mywebstor.com/local/webhooks/calendar/indexv4.php', propsAxios)
            .then((response)=>{
              this.arrProductList=response.data.data.products;
              this.fieldsProduct=response.data.data.fields;
              this.$emit('update:localLoading', false);
            })
            .catch((error)=>{
              this.$root.$emit('sendEventYandexGoogle', "myWebStor_NetErrorGettingDate");
              this.$root.$emit('showSnackBar', {text:error, show:true}); 
              this.$emit('update:localLoading', false);
            });
          }          
        }
        else{
         this.arrProductList=[];
         this.arrProduct=[]; 
        }
      },
      allowedDates:function(val){
        if (this.currNapr==undefined){
          return false;
        }
        var date=new Date(val).setUTCHours(0,0);
        var countPeriod=Math.ceil(this.longPeriod/Number(this.appOptions.settings.sizeGrid));
        var dayCheck=this.dirtRasp.filter((el)=>{
          if (this.currSpec!=undefined){
            return new Date(el.time).setUTCHours(0,0)==date&&el.isFree==true&&el.entity==this.currSpec;
          }
          return new Date(el.time).setUTCHours(0,0)==date&&el.isFree==true
        })
        for (var idx in dayCheck){
          var isFree=true;
          var currTime=new Date(dayCheck[idx].time).getTime();
          for (var jdx=0; jdx<countPeriod; jdx++){            
            if (dayCheck.find(el=>{return el.time==currTime})==undefined){
              isFree=false;
              break;
            }
            currTime=new Date(currTime).setMinutes(new Date(currTime).getMinutes()+Number(this.appOptions.settings.sizeGrid));
          }
          if (isFree){
            return true;
          }
        }
        return false;
      },
      changeNapr:function(){
        this.$emit('update:localLoading', true);
        this.$emit('update:currNapr', this.currNapr);
        if (this.pickerMonthYear.split("-").length!=2||this.currNapr==undefined||!(Number(this.currNapr.value)>0)){
          this.$root.$emit('showSnackBar', {text:this.$t("onlineForm.setNapravl.selectMonth"), show:true});
          return;
        }

        let arrSotr=[];
        this.arrSotr.forEach(el=>{arrSotr.push(el.value)});

        var propsAxios={
          tokenForm:this.formToken,
          action:'getLeadForMonth',
          filial:this.currentFilial&&this.currentFilial.id?this.currentFilial.id:"",
          fieldDate:this.appOptions.settingsWrite.fieldDateWrite,
          fieldMinut:this.appOptions.settingsWrite.fieldCountMinut,
          entity:this.appOptions.settingsWrite.entity,
          month:this.pickerMonthYear.split("-")[1],
          year:this.pickerMonthYear.split("-")[0],
          group:this.currNapr.value,
          sotr:arrSotr,
          catalog:this.currNapr.catalog,
          catalogFields:this.vidgetOptions.fieldsProductForView,
          statusFilter:this.vidgetOptions.statusForHide
        };
        axios.post('https://crm.mywebstor.com/local/webhooks/calendar/indexv4.php', propsAxios)
            .then((response)=>{   
              if (response.data.status=='success'){
                this.$root.$emit('sendEventYandexGoogle', "myWebStor_SuccessGettingDate");
                this.picker=undefined;
                this.$emit('update:dateResourse', undefined);
                this.selectedTime=undefined;
                var placesRasp=[], placesEvents=[];
                // this.arrProductList=response.data.data.products;
                // this.fieldsProduct=response.data.data.productField;
                this.timezoneOffset=response.data.data.timezoneOffset;
                for (var idx in response.data.data.rasp){
                  var curRow=response.data.data.rasp[idx];
                  var arrTime=curRow.timeStart.split(":");
                  var currDataTime=new Date(Number(curRow.date)).getTime()+arrTime[0]*60*60*1000+arrTime[1]*60*1000;//Нужные дата и время в ISO
                  for (var jdx=0; jdx<Number(curRow.countInterval); jdx++){
                    placesRasp.push({
                      time:currDataTime,
                      entity:curRow.entity,
                      value:curRow.value,
                      isFree:true,
                    });
                    currDataTime=new Date(currDataTime).setMinutes(new Date(currDataTime).getMinutes()+Number(this.appOptions.settings.sizeGrid));
                  }
                }
                for (idx in response.data.data.events){
                  curRow=response.data.data.events[idx];
                  placesEvents.push(curRow);
                  currDataTime=new Date(curRow.date).getTime()+this.timezoneOffset*1000;
                  if (Number(curRow.countMinut)>0){
                    var countPeriod=Math.ceil(Number(curRow.countMinut)/Number(this.appOptions.settings.sizeGrid));
                    for (jdx=0; jdx<countPeriod; jdx++){                      
                      var findedEl=placesRasp.find(el=>{
                        return el.isFree&&currDataTime==el.time&&el.entity==curRow.sotr;
                      });
                      currDataTime=new Date(currDataTime).setMinutes(new Date(currDataTime).getMinutes()+Number(this.appOptions.settings.sizeGrid));
                      if (findedEl!=undefined){
                        findedEl.isFree=false;
                      }
                    }
                  }
                }
                this.arrRasp=placesRasp;
                this.arrEvents=placesEvents;
              } 
              else{
                this.$root.$emit('sendEventYandexGoogle', "myWebStor_ErrorGettingDate");
                this.$root.$emit('showSnackBar', {text:response.data.message, show:true});
              }
              this.$emit('update:localLoading', false);
            })
            .catch((error)=>{
              this.$root.$emit('sendEventYandexGoogle', "myWebStor_NetErrorGettingDate");
              this.$root.$emit('showSnackBar', {text:error, show:true}); 
              this.$emit('update:localLoading', false);
            });
          this.$root.$emit('sendEventYandexGoogle', "myWebStor_changeNapravl");
      },
      changeStep:function(){
        if (this.steps[this.currStep-1].value=='setNapravl'){
            this.$emit('update:localLoading', true);
            var propsAxios={
                tokenForm: this.formToken,
                action:'getNapravlAndSotr'
            };
            axios.post('https://crm.mywebstor.com/local/webhooks/calendar/indexv4.php', propsAxios)
            .then((response)=>{         
              if (response.data.status!='success'){                
                this.$root.$emit('showSnackBar', {text:response.data.message, show:true}); 
              }
              else{
                this.arrNapravl=response.data.data.napravl==undefined?[]:response.data.data.napravl;
                this.arrSotr=response.data.data.sotr==undefined?[]:response.data.data.sotr;
              }
              if (this.dateResourse==undefined){
                this.currNapr=undefined;
              }
              this.$emit('update:localLoading', false);
            })
            .catch((error)=>{
              this.$root.$emit('showSnackBar', {text:error, show:true}); 
              this.$emit('update:localLoading', false);
            });
            this.$root.$emit('sendEventYandexGoogle', "myWebStor_stepSetNapr");
          }
          else{
              this.$emit('update:dateResourse', this.selectedTime);
              this.$emit('update:longTime', this.longPeriod);
              this.$emit('update:arrProduct', this.arrProduct);
              this.$emit('update:localLoading', false);
              this.$emit('update:timezoneOffset', this.timezoneOffset);
          }
      },
      getIntervalsFromSchema(schema) {
        let result = [];
        if(schema && schema.type == "intervals") {
          schema.values.forEach(value => {
            for(let i = 0; i < +value.count; i++)
              result.push({
                timeFrom: value.timeFrom,
                timeTo: value.timeTo,
                type: value.type
              });
          });
        }
        return result;
      },
      getDatesInPeriod(srcFrom, srcTo) {
        let from = new Date(srcFrom),
            to = new Date(srcTo);
        let result = [];
        result.push(from.toISOString().split("T")[0]);
        while(from.getTime() != to.getTime()) {
          from.setDate(from.getDate() + 1);
          result.push(from.toISOString().split("T")[0]);
        }
        return result;
      },
      getDatesDiff(current, dateFrom, dateTo) {
        let curr = new Date(current),
            from = new Date(dateFrom),
            to = new Date(dateTo);
        if(curr.getTime() < from.getTime() || (dateTo && curr.getTime() > to.getTime())) return false;
        return Math.abs(curr.getTime() - from.getTime()) / 1000 / 60 / 60 / 24;
      },
      timeToMinutes(time) {
        if(!time) return 0;
        let [hours, minutes] = time.split(":");
        return +hours * 60 + +minutes;
      }
    }, 

    mounted:function(){
      this.changeStep();
    },

    computed:{
      itemsProductForPrint:function(){
        let result=[];
        for (let idx in this.arrProductList){
          let tempObj={
            text:this.arrProductList[idx].text,
            value:this.arrProductList[idx].value,
            time:this.arrProductList[idx].time,
            otherFields:[],
          };
          for (let jdx in this.vidgetOptions.fieldsProductForView){
            if (this.arrProductList[idx][this.vidgetOptions.fieldsProductForView[jdx]]){
              tempObj.otherFields.push({
                label:this.nameFieldsProduct[this.vidgetOptions.fieldsProductForView[jdx]],
                value:this.arrProductList[idx][this.vidgetOptions.fieldsProductForView[jdx]]
              });
            }
          }
          result.push(tempObj);
        }
        return result;
      },
      nameFieldsProduct:function(){
        let result={};
        let filteredFields=this.fieldsProduct.filter(el=>{return this.vidgetOptions.fieldsProductForView.indexOf(el.value)!=-1});
        for (let idx in filteredFields){
          result[filteredFields[idx].value]=filteredFields[idx].text;
        }
        return result;
      },
      currentGroup:function(){
        let result=[];
        if (this.currentFilial&&this.currentFilial.id){
          this.arrNapravl.forEach((el)=>{
            if (el.filial&&el.filial.indexOf(this.currentFilial.id)!=-1){
                result.push(el);
            }
          });
        }
        else{
          this.arrNapravl.forEach((el)=>{
                result.push(el);
          });
        }

        return result;
      },
      currentSpec:function(){
        var result=[];
        if (this.currentFilial&&this.currentFilial.id){
          this.arrSotr.forEach((el)=>{
            if (el.group&&this.currNapr&&this.currNapr.value&&
                  el.group.indexOf(this.currNapr.value)!=-1&&
                  el.filial.indexOf(this.currentFilial.id)!=-1
                ){
                    result.push(el);
            }
          });
        }
        else{
          this.arrSotr.forEach((el)=>{
            if (el.group&&this.currNapr&&this.currNapr.value&&
                  el.group.indexOf(this.currNapr.value)!=-1
                ){
                    result.push(el);
            }
          });
        }
        return result;
      },
      longPeriod:function(){
        var result=0;
        for (var idx in this.arrProduct){
          if (!isNaN(Number(this.arrProduct[idx].time))){
            result+=Number(this.arrProduct[idx].time);
          }
        }
        if (result==0){
          result=Number(this.appOptions.settings.sizeGrid);
        }
        return result;
      },
      times:function(){        
        var result=[];
        let timesInArray=[];
        if (!this.currNapr||!this.picker||!this.currSpec){
          return result;
        }
        var date=this.picker;
        var countPeriod=Math.ceil(this.longPeriod/Number(this.appOptions.settings.sizeGrid));
        var dayCheck=this.dirtRasp.filter((el)=>{
          return new Date(el.time).toISOString().substr(0,10)==date&&el.isFree==true&&el.entity==this.currSpec;
        })
        dayCheck=dayCheck.sort((a,b)=>{
          return a.time-b.time;
        });
        for (var idx in dayCheck){
          var isFree=true;
          var currTime=new Date(dayCheck[idx].time).getTime();
          for (var jdx=0; jdx<countPeriod; jdx++){
            
            if (dayCheck.find(el=>{return el.time==currTime})==undefined){
              isFree=false;
              break;
            }
            currTime=new Date(currTime).setMinutes(new Date(currTime).getMinutes()+Number(this.appOptions.settings.sizeGrid));
          }

          let timeCurrDevice=new Date(new Date().getTime()+this.timezoneOffset*1000).getTime();
          if (isFree&&dayCheck[idx].time>timeCurrDevice){
            let tempObj=Object.assign({},dayCheck[idx]);
            tempObj.text=new Date(tempObj.time).toISOString().substr(11,5);
            if (timesInArray.indexOf(tempObj.text)==-1){
              timesInArray.push(tempObj.text);
              result.push(tempObj);
            }
          }
        }
        return result;
      },
      dirtRasp() {
        let result = [];
        this.arrRasp.forEach(rasp => result.push(rasp));
        let today = new Date(),
            firstDayOfMonth = new Date(this.pickerMonthYear),
            lastDayOfMonth = new Date(this.pickerMonthYear);
        if(today.getFullYear() == firstDayOfMonth.getFullYear()
        && today.getMonth() == firstDayOfMonth.getMonth()) firstDayOfMonth.setDate(today.getDate());
        lastDayOfMonth.setMonth(lastDayOfMonth.getMonth() + 1);
        lastDayOfMonth.setDate(0);
        this.arrSotr
        .filter(sotr => sotr.schedules && sotr.schedules.length)
        .forEach(sotr => {
          sotr.schedules.filter(schedule => schedule.group == this.currNapr.value).forEach(schedule => {
            let schema = schedule.schemas[0];
            if(schema) {
              let intervals = this.getIntervalsFromSchema(schema);
              this.getDatesInPeriod(firstDayOfMonth, lastDayOfMonth).forEach(currDate => {
                let diff = this.getDatesDiff(currDate, schedule.dateFrom, schedule.dateTo);
                if(diff !== false) {
                  let interval = intervals[diff % intervals.length];
                  if(interval && interval.type == "work" && !schedule.exceptions.includes(currDate)) {
                    let timeFrom = this.timeToMinutes(interval.timeFrom),
                        timeTo = this.timeToMinutes(interval.timeTo),
                        date = new Date(currDate);
                    date.setHours(0, timeFrom + this.timezoneOffset / 60, 0, 0);
                    while(timeFrom < timeTo) {
                      result.push({
                        time: date.getTime(),
                        entity: sotr.value,
                        value: "0",
                        isFree: true
                      });
                      date.setTime(date.getTime() + +this.appOptions.settings.sizeGrid * 60 * 1000);
                      timeFrom += +this.appOptions.settings.sizeGrid;
                    }
                  }
                }
              });
            }
          });
        });
        this.arrEvents.forEach(event => {
          let from = new Date(event.date),
              to = new Date(from);
          from.setMinutes(from.getMinutes() + this.timezoneOffset / 60);
          to.setMinutes(to.getMinutes() + +event.countMinut + this.timezoneOffset / 60);
          result.filter(rasp => {
            return rasp.time >= from.getTime() && rasp.time < to.getTime()
          }).forEach(rasp => rasp.isFree = false);
        });
        return result;
      }
    },

    props:{
      vidgetOptions:undefined,
      currStep:undefined,
      currentFilial:undefined,
      steps:undefined,
      formToken:undefined,
      appOptions:undefined,
      localLoading:undefined,
      dateResourse:undefined,
    },

    components:{

    },

    watch:{
      dateResourse:function(){
        if (this.dateResourse==undefined){
          this.currNapr=undefined;
        }
      },
      pickerMonthYear:function(){
        if (this.currNapr==undefined){
          return;
        }
        this.changeNapr();
      },
      currStep:function(){
        this.changeStep();
      }
    },

    data: () => ({
      arrProduct:[],
      selectedTime:undefined,
      arrProductList:[],
      fieldsProduct:[],
      picker:undefined,
      pickerMonthYear:undefined,
      arrNapravl:[],
      arrSotr:[],
      currNapr:undefined,
      currSpec:undefined,
      arrRasp:[],
      arrEvents:[],
      timezoneOffset:0,
    }),
  }
</script>

<style>

</style>
